import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { CartState } from "@core/types";
import { cartClient } from "@core/clients";

type UpdateCartVariables = {
  cart: CartState;
  shippingZone: string;
};

const useUpdateCart = (
  options?: Omit<UseMutationOptions<CartState | null, any, UpdateCartVariables, Record<string, CartState | undefined>>, "mutationFn" | "mutationKey">
) => {
  return useMutation( 
    ["cart-update"],
    async ({ cart, shippingZone }) => {
      return cartClient.updateCart(cart, shippingZone);
    },
    {

      ...options,
    }
  );
};

export default useUpdateCart;
